import {
  RiDashboardLine,
  RiUserLine,
  RiBankLine,
  RiFileChartLine,
  RiSettingsLine,
  RiTeamLine,
  RiShieldUserLine,
  RiAppsLine,
  RiFileListLine,
  RiRadioButtonLine,
  RiSearchLine,
} from 'react-icons/ri'
import { IconType } from 'react-icons'

const ASIDE_GRADIENT_START = '#1a3c6e'
export const ASIDE_ACCENT = '#0e7490'
export const ASIDE_GRADIENT = `linear-gradient(135deg, ${ASIDE_GRADIENT_START} 0%, ${ASIDE_ACCENT} 100%)`
export const ASIDE_ACTIVE_BG = '#f0f9ff'
export const ASIDE_ICON_MUTED = '#64748b'
export const ASIDE_TEXT = '#1e293b'

export { RiSearchLine }

const ICON_MAP: Array<{ keywords: string[]; icon: IconType }> = [
  { keywords: ['dashboard'], icon: RiDashboardLine },
  { keywords: ['profile'], icon: RiUserLine },
  { keywords: ['account'], icon: RiBankLine },
  { keywords: ['report'], icon: RiFileChartLine },
  { keywords: ['setting'], icon: RiSettingsLine },
  { keywords: ['user'], icon: RiTeamLine },
  { keywords: ['role'], icon: RiShieldUserLine },
  { keywords: ['module'], icon: RiAppsLine },
  { keywords: ['log'], icon: RiFileListLine },
]

export function getMenuIcon(title: string): IconType {
  const lower = title.toLowerCase()
  const match = ICON_MAP.find(({ keywords }) =>
    keywords.some((k) => lower.includes(k))
  )
  return match ? match.icon : RiRadioButtonLine
}
